import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'PROFESSIONAL VISUAL EXPLANATIONS.', 'STRUCTURED TEACHING RESOURCES.', 'INDUSTRIAL HAZARD DIAGRAMS.', 'REALISTIC WORKPLACE SCENARIOS.', 'INSTRUCTOR ASSESSMENT TOOLS.', 'CLEAR TRAINING ACTIVITIES.', 'BETTER LESSON PREPARATION.'];
const alreadyHave = ['You already have the workplace hazard illustrations.', 'You already have the warehouse safety examples.', 'You already have the industrial machinery diagrams.', 'You already have the fire and electrical hazard references.', 'You already have the fall prevention material.', 'You already have the PPE and occupational health resources.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-line" data-id="element-65" data-mp="214t99iw764e6">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-66" data-mp="2164d1ipn7c5a">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-ink mb-6 uppercase" data-id="element-67" data-mp="28vwoty8mogom">
          You Don&apos;t Need More Random{' '}
          <span className="text-forest" data-id="element-68" data-mp="1v3yvowvbave3">Workplace Safety Training Material.</span>
        </h2>
        <p className="text-xl text-graphite/80 mb-5" data-id="element-69" data-mp="202jnc7wi06qx">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-70" data-mp="1l6u60n29chsj">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-forest tracking-wide" data-id="element-71" data-mp="1q804z2mih1ai">
              {need}
            </li>)}
        </ul>
        <div className="bg-mist border border-line rounded-2xl p-8 text-lg text-graphite space-y-2 text-left sm:text-center" data-id="element-72" data-mp="1h58r6w65xtfp">
          <p className="mb-4" data-id="element-73" data-mp="36lhu8bxy6a6b">
            With WORKPLACE SAFETY ATLAS, you don&apos;t start every training session searching through
            disconnected resources.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-ink font-semibold flex items-center sm:justify-center gap-2" data-id="element-74" data-mp="3931s6ofbjt6r">
              <Check size={18} className="text-forest shrink-0" aria-hidden="true" data-id="element-75" data-mp="303wx5s2yuhzc" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-76" data-mp="2v7g7gtg4bvk5">
            And with the five professional bonuses, you also have additional written materials to help
            you plan, teach, challenge and assess your students.
          </p>
          <p className="font-display text-2xl md:text-3xl font-extrabold tracking-tight text-ink" data-id="element-77" data-mp="3nwdmmnp19c8o">
            YOU ALREADY HAVE <span className="text-gold" data-id="element-78" data-mp="3e4hc2d5rftnk">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}